@if (config()) {
  <div class="parameter-timespan-config">
    @if (!hideLabel()) {
      <div class="parameter-timespan-config__title">{{ parameterTitle }}:</div>
    }
    <div class="parameter-timespan-config__wrapper">
      @if (hasYear()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Year</mat-label>
          <input
            type="number"
            matInput
            [(ngModel)]="year"
            [disabled]="disabled()"
            (change)="onChangeYear($event)"
          />
        </mat-form-field>
      }
      @if (hasMonth()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Month</mat-label>
          <input
            type="number"
            matInput
            [(ngModel)]="month"
            [disabled]="disabled()"
            (change)="onChangeMonth($event)"
          />
        </mat-form-field>
      }
      @if (hasDay()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Day</mat-label>
          <input
            type="number"
            matInput
            [(ngModel)]="day"
            [disabled]="disabled()"
            (change)="onChangeDay($event)"
          />
        </mat-form-field>
      }
      @if (hasHour()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Hour</mat-label>
          <input
            type="number"
            matInput
            [(ngModel)]="hour"
            [disabled]="disabled()"
            (change)="onChangeHour($event)"
          />
        </mat-form-field>
      }
      @if (hasMinute()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Minute</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="minute"
            [disabled]="disabled()"
            (change)="onChangeMinute($event)"
          />
        </mat-form-field>
      }
      @if (hasSecond()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Second</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="second"
            [disabled]="disabled()"
            (change)="onChangeSecond($event)"
          />
        </mat-form-field>
      }
      @if (hasMillisecond()) {
        <mat-form-field
          class="parameter-timespan-config__field without-subscript small-form-field"
          appearance="outline"
        >
          <mat-label>Millisecond</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="millisecond"
            [disabled]="disabled()"
            (change)="onChangeMillisecond($event)"
          />
        </mat-form-field>
      }
    </div>
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-timespan-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasDelete() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickRemove()"
            class="parameter-timespan-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasUndo() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickUndo()"
            class="parameter-timespan-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (hasClose() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
        </button>
      </div>
    }
    @if (showReset() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button (click)="onResetToFactory()" [matTooltip]="resetToFactoryTooltip()">
          <mat-icon color="warn">replay</mat-icon>
        </button>
      </div>
    }
  </div>
}
